import { Component, Input, OnInit } from '@angular/core';
import { Delivery, StatusButtons } from "../../../../_shared/interfaces";
import { RouterLink } from "@angular/router";
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule } from "@clr/angular";
import { DeliveryStoreService } from "../../../../_shared/services";
import { DatePipe, NgIf } from "@angular/common";

@Component({
  selector: 'app-project-details-delivery',
  standalone: true,
  imports: [
    ClrDatagridModule,
    NgIf,
    RouterLink,
    DatePipe,
    ClrIconModule
  ],
  templateUrl: './project-details-delivery.component.html',
  styleUrl: './project-details-delivery.component.sass'
})
export class ProjectDetailsDeliveryComponent implements OnInit {

  deliveries: Delivery[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;

  @Input() cidstd: number = 0;
  @Input() pridstd: string = '';

  constructor(
      private delss: DeliveryStoreService,
  ){}

  ngOnInit(){

    this.loading = true;
    this.loadList();
  }

  statusButtons: StatusButtons[] = [
    { state: 'open',   display: 'Offen',   label: 'alert-info',    icon: 'info-circle'},
    { state: 'closed', display: 'Gebucht', label: 'alert-success', icon: 'check-circle'},
    { state: 'noinvoice', display: 'Ohne Rechnung', label: 'alert-warning', icon: 'exclamation-triangle'}
  ];

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(projectstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === projectstatus)
  };

  getCellStatus(invoicestatus: string) {
    // findButtonStatus liefert -1, wenn der Status unbekannt ist -- ein
    // direkter Zugriff darauf wirft und reisst die ganze Tabelle mit. Genau so
    // blieb der Lieferschein-Reiter leer bzw. im Ladekreis haengen, als das
    // Vokabular um einen Status erweitert wurde, den diese Liste nicht kannte.
    const treffer = this.statusButtons[this.findButtonStatus(invoicestatus, this.statusButtons)];
    return treffer?.label ?? 'label-light-blue';
  }

  loadList() {
    this.delss.getDelivery(this.cidstd + '.' + this.pridstd, 0, 0, 'all').subscribe(data => {
      if (!data) {
        return;
      }

      this.deliveries = data.object;
      this.loading = false;
      this.descSort = ClrDatagridSortOrder.DESC;
    });
  }

  findButtonClass(invoicestatus: string) {
    return "alert " + this.getCellStatus(invoicestatus) + " alert-sm";
  }
}
